import React, { useState } from "react";
import PageHeader from "../routes/pageHeader";

const Profile = () => {
  return <div></div>;
};

export default Profile;
